// eslint-disable-next-line no-restricted-imports
import { Avatar as AntAvatar } from 'antd';
import styled from 'styled-components';
const { Group: AntAvatarGroup } = AntAvatar;
export const AvatarGroup = styled(AntAvatarGroup)`
  &.ant-avatar-group {
    gap: ${(props)=>{
    var _props_gap;
    return (_props_gap = props.gap) !== null && _props_gap !== void 0 ? _props_gap : '0px';
}};
  }
  .ant-avatar {
    border: none;
    box-shadow: 0 0 0 1px var(--white-100);

    &:not(:first-child) {
      margin-left: calc(-1 * var(--spacing-02));
    }

    &:last-child {
      color: var(--white-100);
    }
  }

  .ant-badge {
    + .ant-avatar,
    + .ant-badge {
      margin-left: 0;
    }

    + .ant-avatar:last-child {
      margin-left: 0;
      font-size: var(--font-size-sm);
      height: var(--avatar-size-sm);
      line-height: var(--avatar-size-sm);
      width: var(--avatar-size-sm);
    }
  }

  .ant-avatar-sm + .ant-avatar:not(.ant-scroll-number-custom-component) {
    font-size: var(--font-size-sm);
    height: var(--avatar-size-sm);
    line-height: var(--avatar-size-sm);
    width: var(--avatar-size-sm);
  }

  .ant-avatar-lg
    + .ant-avatar:last-child:not(.ant-scroll-number-custom-component) {
    height: var(--avatar-size-lg);
    line-height: var(--avatar-size-lg);
    width: var(--avatar-size-lg);
  }
`;
